import { render } from "./ProjectSetting.vue?vue&type=template&id=58f2bb86&scoped=true&ts=true"
import script from "./ProjectSetting.vue?vue&type=script&lang=ts"
export * from "./ProjectSetting.vue?vue&type=script&lang=ts"

import "./ProjectSetting.vue?vue&type=style&index=0&id=58f2bb86&scoped=true&lang=css"
import "./ProjectSetting.vue?vue&type=style&index=1&id=58f2bb86&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f2bb86"]])

export default __exports__